{
  "ai-rovo.actions-software-backlog.nudge-description.nonfinal": [
    {
      "type": 0,
      "value": "We have identified "
    },
    {
      "type": 1,
      "value": "numberOfSuggestions"
    },
    {
      "type": 0,
      "value": " work item "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "update"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "updates"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "numberOfSuggestions"
    }
  ],
  "ai-rovo.actions-software-backlog.nudge-icon-label.nonfinal": [
    {
      "type": 0,
      "value": "Work items icon"
    }
  ],
  "ai-rovo.actions-software-backlog.nudge-title.nonfinal": [
    {
      "type": 0,
      "value": "You have "
    },
    {
      "type": 1,
      "value": "numberOfSuggestions"
    },
    {
      "type": 0,
      "value": " work item "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 0,
              "value": "update"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "updates"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "numberOfSuggestions"
    }
  ],
  "jira-issueview-quickactions.src.ui.index.recommended-for-you": [
    {
      "type": 0,
      "value": "Recommended for you"
    }
  ],
  "jira-project-term-refresh-changeboarding-flag.message-templates.flag.description.now": [
    {
      "type": 0,
      "value": "Everything else about how you use these containers remains the same."
    }
  ],
  "jira-project-term-refresh-changeboarding-flag.message-templates.flag.description.soon": [
    {
      "type": 0,
      "value": "Jira 'projects' will soon be renamed 'spaces'"
    }
  ],
  "jira-project-term-refresh-changeboarding-flag.message-templates.flag.learn-more": [
    {
      "type": 0,
      "value": "Read more about this change"
    }
  ],
  "jira-project-term-refresh-changeboarding-flag.message-templates.flag.title.now": [
    {
      "type": 0,
      "value": "Jira 'projects' are now called 'spaces'"
    }
  ],
  "jira-project-term-refresh-changeboarding-flag.message-templates.flag.title.soon": [
    {
      "type": 0,
      "value": "Coming soon"
    }
  ],
  "jira-pulsar.common.components.cross-flow.add": [
    {
      "type": 0,
      "value": "Add"
    }
  ],
  "jira-pulsar.common.components.cross-flow.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-pulsar.common.components.issue-view-description-ad.close": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "jira-pulsar.jira-comment-mention.message-template.notification-drawer.message": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": " mentioned you in a comment"
    }
  ],
  "jira-pulsar.jira-comment-mention.message-template.notification-drawer.message.anonymous": [
    {
      "type": 0,
      "value": "You've been mentioned in a comment"
    }
  ],
  "jira-pulsar.jira-common.celebration-icon.body_image_alt": [
    {
      "type": 0,
      "value": "Celebration icon"
    }
  ],
  "jira-pulsar.jira-common.exclamation-icon.body_image_alt": [
    {
      "type": 0,
      "value": "Exclamation icon"
    }
  ],
  "jira-pulsar.jira-common.jira-logo.alt_text": [
    {
      "type": 0,
      "value": "Jira logo"
    }
  ],
  "jira-pulsar.jira-common.message-template.text.body.display.old.field.value": [
    {
      "type": 0,
      "value": "was: "
    },
    {
      "type": 1,
      "value": "oldFieldValue"
    }
  ],
  "jira-pulsar.jira-common.redesign.footer.atlassian-logo.no-translate": [
    {
      "type": 0,
      "value": "Atlassian logo"
    }
  ],
  "jira-pulsar.jira-common.right-arrow-icon.no-translate": [
    {
      "type": 0,
      "value": "&#x2192;"
    }
  ],
  "jira-pulsar.jira-contact-admin.message-template.email.body.from.contact.admin": [
    {
      "type": 0,
      "value": "From:"
    }
  ],
  "jira-pulsar.jira-contact-admin.message-template.email.body.new.message.from.contact.admin": [
    {
      "type": 0,
      "value": "New message from Contact Administrators page"
    }
  ],
  "jira-pulsar.jira-contact-admin.message-template.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] "
    },
    {
      "type": 1,
      "value": "header"
    }
  ],
  "jira-pulsar.jira-issue-approval-decided.right.arrow.image.alt.no-translate": [
    {
      "type": 0,
      "value": "->"
    }
  ],
  "jira-pulsar.jira-issue-approval.message-template.email.approval.assigned.to": [
    {
      "type": 0,
      "value": "Assigned to: "
    },
    {
      "type": 1,
      "value": "assignee"
    }
  ],
  "jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers": [
    {
      "type": 0,
      "value": "Approvers: "
    }
  ],
  "jira-pulsar.jira-issue-approval.message-template.email.approval.event.approvers.plus.no-translate": [
    {
      "type": 0,
      "value": "+"
    }
  ],
  "jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.by.user.subject": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " has approved "
    },
    {
      "type": 1,
      "value": "issueLabel"
    }
  ],
  "jira-pulsar.jira-issue-approval.message-template.email.approval.issue.approved.subject": [
    {
      "type": 1,
      "value": "issueLabel"
    },
    {
      "type": 0,
      "value": " has been approved"
    }
  ],
  "jira-pulsar.jira-issue-approval.message-template.email.approval.issue.declined.by.user.subject": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " has declined "
    },
    {
      "type": 1,
      "value": "issueLabel"
    }
  ],
  "jira-pulsar.jira-issue-approval.message-template.email.approval.required": [
    {
      "type": 1,
      "value": "issueLink"
    },
    {
      "type": 0,
      "value": " requires your approval"
    }
  ],
  "jira-pulsar.jira-issue-approval.message-template.email.approval.required.subject": [
    {
      "type": 0,
      "value": "Approval required: "
    },
    {
      "type": 1,
      "value": "issueLabel"
    }
  ],
  "jira-pulsar.jira-issue-approval.message-template.email.footer.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "jira-pulsar.jira-issue-approval.message-template.email.unassigned": [
    {
      "type": 0,
      "value": "Unassigned"
    }
  ],
  "jira-pulsar.jira-issue-archived.message-template.redacted.email.subject": [
    {
      "type": 0,
      "value": "("
    },
    {
      "type": 1,
      "value": "issueKey"
    },
    {
      "type": 0,
      "value": ") work item was archived"
    }
  ],
  "jira-pulsar.jira-issue-assign.message-template-template.email.body.heading": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "assigned"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " this work item to you"
    }
  ],
  "jira-pulsar.jira-issue-assign.message-template.email.html.subject": [
    {
      "type": 0,
      "value": "[JIRA] "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " assigned "
    },
    {
      "type": 1,
      "value": "issueKey"
    },
    {
      "type": 0,
      "value": " to you"
    }
  ],
  "jira-pulsar.jira-issue-assign.message-template.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " assigned "
    },
    {
      "type": 1,
      "value": "issueKey"
    },
    {
      "type": 0,
      "value": " to you"
    }
  ],
  "jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.assigned.anonymous.issue-terminology-refresh-m4": [
    {
      "type": 0,
      "value": "You've been assigned to "
    },
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "a bug"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "an epic"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "a request"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "an idea"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "a story"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "a subtask"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "a task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "a work item"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    }
  ],
  "jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.assigned.issue-terminology-refresh-m4": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " assigned "
    },
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "a bug"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "an epic"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "a request"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "an idea"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "a story"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "a subtask"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "a task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "a work item"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    },
    {
      "type": 0,
      "value": " to you"
    }
  ],
  "jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.unassigned.anonymous.issue-terminology-refresh-m4": [
    {
      "type": 0,
      "value": "You've been unassigned from "
    },
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "a bug"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "an epic"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "a request"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "an idea"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "a story"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "a subtask"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "a task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "a work item"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    }
  ],
  "jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.direct.unassigned.issue-terminology-refresh-m4": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " unassigned you from "
    },
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "a bug"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "an epic"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "a request"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "an idea"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "a story"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "a subtask"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "a task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "a work item"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    }
  ],
  "jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assigned.anonymous": [
    {
      "type": 0,
      "value": "There's a new assignee on an issue"
    }
  ],
  "jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assigned.anonymous.issue-terminology-refresh-m4": [
    {
      "type": 0,
      "value": "There's a new assignee on "
    },
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "a bug"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "an epic"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "a request"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "an idea"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "a story"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "a subtask"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "a task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "a work item"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    }
  ],
  "jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assigned.issue-terminology-refresh-m4": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " assigned "
    },
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "a bug"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "an epic"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "a request"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "an idea"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "a story"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "a subtask"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "a task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "a work item"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    },
    {
      "type": 0,
      "value": " to "
    },
    {
      "type": 1,
      "value": "newAssignee"
    }
  ],
  "jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.assignee.change.issue-terminology-refresh-m4": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " reassigned "
    },
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "a bug"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "an epic"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "a request"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "an idea"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "a story"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "a subtask"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "a task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "a work item"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    },
    {
      "type": 0,
      "value": " from "
    },
    {
      "type": 1,
      "value": "oldAssignee"
    },
    {
      "type": 0,
      "value": " to "
    },
    {
      "type": 1,
      "value": "newAssignee"
    }
  ],
  "jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.unassigned.anonymous.issue-terminology-refresh-m4": [
    {
      "type": 0,
      "value": "The "
    },
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "bug's"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "epic's"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "request's"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "idea's"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "story's"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "subtask's"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "task's"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "work item's"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    },
    {
      "type": 0,
      "value": " assignee has been removed"
    }
  ],
  "jira-pulsar.jira-issue-assign.message-template.notification-drawer.message.watcher.unassigned.issue-terminology-refresh-m4": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " unassigned "
    },
    {
      "type": 1,
      "value": "oldAssignee"
    },
    {
      "type": 0,
      "value": " from "
    },
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "a bug"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "an epic"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "a request"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "an idea"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "a story"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "a subtask"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "a task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "a work item"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    }
  ],
  "jira-pulsar.jira-issue-assigned.email.body.assignee": [
    {
      "type": 0,
      "value": "Assignee"
    }
  ],
  "jira-pulsar.jira-issue-assigned.email.body.unassigned": [
    {
      "type": 0,
      "value": "Unassigned"
    }
  ],
  "jira-pulsar.jira-issue-comment-delete.email.body.deleted": [
    {
      "type": 0,
      "value": "Deleted"
    }
  ],
  "jira-pulsar.jira-issue-comment-delete.message-template.hipppa.view.update": [
    {
      "type": 0,
      "value": "Comment: "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "View update"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "jira-pulsar.jira-issue-comment-delete.message-template.redacted.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] ("
    },
    {
      "type": 1,
      "value": "issuekey"
    },
    {
      "type": 0,
      "value": ") Work item was updated"
    }
  ],
  "jira-pulsar.jira-issue-comment-update.email.body.added": [
    {
      "type": 0,
      "value": "Added"
    }
  ],
  "jira-pulsar.jira-issue-comment-update.email.body.deleted": [
    {
      "type": 0,
      "value": "Deleted"
    }
  ],
  "jira-pulsar.jira-issue-comment-update.email.body.edited": [
    {
      "type": 0,
      "value": "Edited"
    }
  ],
  "jira-pulsar.jira-issue-comment-update.message-template.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] ("
    },
    {
      "type": 1,
      "value": "issuekey"
    },
    {
      "type": 0,
      "value": ") "
    },
    {
      "type": 1,
      "value": "summary"
    }
  ],
  "jira-pulsar.jira-issue-comment-update.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4": [
    {
      "type": 0,
      "value": "There's a new update in a comment on "
    },
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "a bug"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "an epic"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "a request"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "an idea"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "a story"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "a subtask"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "a task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "a work item"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    }
  ],
  "jira-pulsar.jira-issue-comment-update.message-template.notification-drawer.message.issue-terminology-refresh-m4": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " updated the comment on "
    },
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "a bug"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "an epic"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "a request"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "an idea"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "a story"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "a subtask"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "a task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "a work item"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    }
  ],
  "jira-pulsar.jira-issue-comment-update.message-template.redacted.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] ("
    },
    {
      "type": 1,
      "value": "issuekey"
    },
    {
      "type": 0,
      "value": ") Work item was updated"
    }
  ],
  "jira-pulsar.jira-issue-comment.body_image_alt": [
    {
      "type": 0,
      "value": "Icon for comment on a Jira issue"
    }
  ],
  "jira-pulsar.jira-issue-comment.email.body.add-comment": [
    {
      "type": 0,
      "value": "Add comment"
    }
  ],
  "jira-pulsar.jira-issue-comment.email.body.view-comment": [
    {
      "type": 0,
      "value": "View comment"
    }
  ],
  "jira-pulsar.jira-issue-comment.message-template.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " commented on "
    },
    {
      "type": 1,
      "value": "issuekey"
    }
  ],
  "jira-pulsar.jira-issue-comment.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4": [
    {
      "type": 0,
      "value": "There's a new comment on "
    },
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "a bug"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "an epic"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "a request"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "an idea"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "a story"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "a subtask"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "a task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "a work item"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    }
  ],
  "jira-pulsar.jira-issue-comment.message-template.notification-drawer.message.issue-terminology-refresh-m4": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " commented on "
    },
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "a bug"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "an epic"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "a request"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "an idea"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "a story"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "a subtask"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "a task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "a work item"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    }
  ],
  "jira-pulsar.jira-issue-create.email.body.unassigned": [
    {
      "type": 0,
      "value": "Unassigned"
    }
  ],
  "jira-pulsar.jira-issue-create.message-template.notification-drawer.message": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " created "
    },
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "a bug"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "an epic"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "a request"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "an idea"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "a story"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "a subtask"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "a task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "a work item"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    }
  ],
  "jira-pulsar.jira-issue-delete.message-template.notification-drawer.message": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " deleted "
    },
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "a bug"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "an epic"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "a request"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "an idea"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "a story"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "a subtask"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "a task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "a work item"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    }
  ],
  "jira-pulsar.jira-issue-mention.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4": [
    {
      "type": 0,
      "value": "You've been mentioned on "
    },
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "a bug"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "an epic"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "a request"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "an idea"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "a story"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "a subtask"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "a task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "a work item"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    }
  ],
  "jira-pulsar.jira-issue-mention.message-template.notification-drawer.message.issue-terminology-refresh-m4": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": " mentioned you on "
    },
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "a bug"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "an epic"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "a request"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "an idea"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "a story"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "a subtask"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "a task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "a work item"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    }
  ],
  "jira-pulsar.jira-issue-moved.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "[JIRA] "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " moved "
    },
    {
      "type": 1,
      "value": "issuekey"
    }
  ],
  "jira-pulsar.jira-issue-moved.message-template.redacted.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] "
    },
    {
      "type": 1,
      "value": "issueKey"
    },
    {
      "type": 0,
      "value": " Work item was updated"
    }
  ],
  "jira-pulsar.jira-issue-reopen.message-template-template.email.body.img.alt.no-translate": [
    {
      "type": 0,
      "value": "Description of image"
    }
  ],
  "jira-pulsar.jira-issue-reopen.test-message.email.body.hello.no-translate": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "jira-pulsar.jira-issue-reopen.test-message.email.body.regards.no-translate": [
    {
      "type": 0,
      "value": "Team Post Office"
    }
  ],
  "jira-pulsar.jira-issue-reopen.test-message.email.body.signoff.no-translate": [
    {
      "type": 0,
      "value": "Regards,"
    }
  ],
  "jira-pulsar.jira-issue-reopened.message-template.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] ("
    },
    {
      "type": 1,
      "value": "issuekey"
    },
    {
      "type": 0,
      "value": ") Work item was updated"
    }
  ],
  "jira-pulsar.jira-issue-transitioned.message-template.notification-drawer.message.anonymous.issue-terminology-refresh-m4": [
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "A bug"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "An epic"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "A request"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "An idea"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "A story"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "A subtask"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "A task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "A work item"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    },
    {
      "type": 0,
      "value": " has been transitioned from "
    },
    {
      "type": 1,
      "value": "fromStatus"
    },
    {
      "type": 0,
      "value": " to "
    },
    {
      "type": 1,
      "value": "toStatus"
    }
  ],
  "jira-pulsar.jira-issue-transitioned.message-template.notification-drawer.message.issue-terminology-refresh-m4": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " changed "
    },
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "a bug"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "an epic"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "a request"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "an idea"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "a story"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "a subtask"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "a task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "a work item"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    },
    {
      "type": 0,
      "value": " from "
    },
    {
      "type": 1,
      "value": "fromStatus"
    },
    {
      "type": 0,
      "value": " to "
    },
    {
      "type": 1,
      "value": "toStatus"
    }
  ],
  "jira-pulsar.jira-issue-update.email.body.slash.no-translate": [
    {
      "type": 0,
      "value": " → "
    }
  ],
  "jira-pulsar.jira-issue-update.message-template.changeby": [
    {
      "type": 0,
      "value": "Change by: "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "actioner"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "jira-pulsar.jira-issue-update.message-template.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " updated "
    },
    {
      "type": 1,
      "value": "issuekey"
    }
  ],
  "jira-pulsar.jira-issue-update.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "[JIRA] "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " updated "
    },
    {
      "type": 1,
      "value": "issuekey"
    }
  ],
  "jira-pulsar.jira-issue-update.message-template.hipppa.view.update": [
    {
      "children": [
        {
          "type": 0,
          "value": "View update"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "jira-pulsar.jira-issue-update.message-template.notification-drawer.message": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " updated "
    },
    {
      "options": {
        "Bug": {
          "value": [
            {
              "type": 0,
              "value": "a bug"
            }
          ]
        },
        "Epic": {
          "value": [
            {
              "type": 0,
              "value": "an epic"
            }
          ]
        },
        "Generalrequest": {
          "value": [
            {
              "type": 0,
              "value": "a request"
            }
          ]
        },
        "Idea": {
          "value": [
            {
              "type": 0,
              "value": "an idea"
            }
          ]
        },
        "Story": {
          "value": [
            {
              "type": 0,
              "value": "a story"
            }
          ]
        },
        "Subtask": {
          "value": [
            {
              "type": 0,
              "value": "a subtask"
            }
          ]
        },
        "Task": {
          "value": [
            {
              "type": 0,
              "value": "a task"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 0,
              "value": "a work item"
            }
          ]
        }
      },
      "type": 5,
      "value": "issueType"
    }
  ],
  "jira-pulsar.jira-issue-work-started.message-template.email.body.started": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "started work on this work item"
        }
      ],
      "type": 8,
      "value": "color"
    }
  ],
  "jira-pulsar.jira-issue-work-started.message-template.email.redacted.subject": [
    {
      "type": 0,
      "value": "[JIRA] ("
    },
    {
      "type": 1,
      "value": "issuekey"
    },
    {
      "type": 0,
      "value": ") Work item was updated"
    }
  ],
  "jira-pulsar.jira-issue-work-stopped.message-template.email.body.stopped": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "stopped work on this work item"
        }
      ],
      "type": 8,
      "value": "color"
    }
  ],
  "jira-pulsar.jira-issue-work-stopped.message-template.email.redacted.subject": [
    {
      "type": 0,
      "value": "[JIRA] ("
    },
    {
      "type": 1,
      "value": "issuekey"
    },
    {
      "type": 0,
      "value": ") Work item was updated"
    }
  ],
  "jira-pulsar.jira-issue-worklog-delete.email.body.deleted": [
    {
      "type": 0,
      "value": "Deleted"
    }
  ],
  "jira-pulsar.jira-issue-worklog-delete.email.body.work.log.deleted": [
    {
      "type": 0,
      "value": "Deleted"
    }
  ],
  "jira-pulsar.jira-issue-worklog-update.email.body.edited": [
    {
      "type": 0,
      "value": "Edited"
    }
  ],
  "jira-pulsar.jira-issue-worklog.message-template.email.body.add.worklog.title": [
    {
      "children": [
        {
          "type": 1,
          "value": "actioner"
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "added a worklog"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " on "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "issueKey"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira-pulsar.jira-issue-worklog.message-template.email.body.change.by": [
    {
      "children": [
        {
          "type": 1,
          "value": "actioner"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.add.comment": [
    {
      "children": [
        {
          "type": 0,
          "value": "Add Comment"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.description": [
    {
      "children": [
        {
          "type": 0,
          "value": "View work description"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "jira-pulsar.jira-issue-worklog.message-template.email.body.worklog.entry.logged.by": [
    {
      "type": 1,
      "value": "entry"
    },
    {
      "type": 0,
      "value": " logged by "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "actioner"
        }
      ],
      "type": 8,
      "value": "a"
    }
  ],
  "jira-pulsar.jira-issue-worklogged.body_image_alt": [
    {
      "type": 0,
      "value": "Product logo"
    }
  ],
  "jira-xflow-confluence.placements.in-app.jira-issueview-comment.confluence": [
    {
      "type": 0,
      "value": "Confluence"
    }
  ],
  "jira-xflow-confluence.placements.in-app.jira-issueview-comment.ctaMessageForIssueComment": [
    {
      "type": 0,
      "value": "Try"
    }
  ],
  "jira-xflow-confluence.placements.in-app.jira-issueview-comment.descriptionForIssuecomment": [
    {
      "type": 0,
      "value": "Put the details in a page to keep the description short"
    }
  ],
  "jira-xflow-confluence.placements.in-app.jira-issueview-comment.titleForIssueComment": [
    {
      "type": 0,
      "value": "Create a page"
    }
  ],
  "jira-xflow-confluence.placements.in-app.jira-issueview-description-template.confluence": [
    {
      "type": 0,
      "value": "Confluence"
    }
  ],
  "jira-xflow-confluence.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription": [
    {
      "type": 0,
      "value": "Try"
    }
  ],
  "jira-xflow-confluence.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription": [
    {
      "type": 0,
      "value": "Put the details in a page to keep the description short"
    }
  ],
  "jira-xflow-confluence.placements.in-app.jira-issueview-description-template.titleForIssueDescription": [
    {
      "type": 0,
      "value": "Create a page"
    }
  ],
  "jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.add": [
    {
      "type": 0,
      "value": "Add"
    }
  ],
  "jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.confluence": [
    {
      "type": 0,
      "value": "Confluence"
    }
  ],
  "jira-xflow-confluence.placements.in-app.jira-issueview-quickactions.page": [
    {
      "type": 0,
      "value": "Page"
    }
  ],
  "jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.ctaMessageForIssueComment": [
    {
      "type": 0,
      "value": "Try"
    }
  ],
  "jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.descriptionForIssuecomment": [
    {
      "type": 0,
      "value": "Capture ideas and insights"
    }
  ],
  "jira-xflow-jpd.placements.in-app.jira-issueview-comment-template.jpd": [
    {
      "type": 0,
      "value": "Jira Product Discovery"
    }
  ],
  "jira-xflow-jpd.placements.in-app.jira-issueview-description-template.ctaMessageForIssueDescription": [
    {
      "type": 0,
      "value": "Try"
    }
  ],
  "jira-xflow-jpd.placements.in-app.jira-issueview-description-template.descriptionForIssueDescription": [
    {
      "type": 0,
      "value": "Capture ideas and insights"
    }
  ],
  "jira-xflow-jpd.placements.in-app.jira-issueview-description-template.jpd": [
    {
      "type": 0,
      "value": "Jira Product Discovery"
    }
  ],
  "jira-xflow-jpd.placements.in-app.jira-issueview-description-template.titleForIssueDescription": [
    {
      "type": 0,
      "value": "Idea"
    }
  ],
  "jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.add": [
    {
      "type": 0,
      "value": "Add"
    }
  ],
  "jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.idea": [
    {
      "type": 0,
      "value": "Idea"
    }
  ],
  "jira-xflow-jpd.placements.in-app.jira-issueview-quickactions.jpd": [
    {
      "type": 0,
      "value": "Jira Product Discovery"
    }
  ],
  "jira-xflow-loom.placements.in-app.jira-issueview-comment.ctaMessageForIssueComment": [
    {
      "type": 0,
      "value": "Try"
    }
  ],
  "jira-xflow-loom.placements.in-app.jira-issueview-comment.descriptionForIssuecomment": [
    {
      "type": 0,
      "value": "Record a comment"
    }
  ],
  "jira-xflow-loom.placements.in-app.jira-issueview-comment.loom": [
    {
      "type": 0,
      "value": "Loom"
    }
  ],
  "jira-xflow-loom.placements.in-app.jira-issueview-description.ctaMessageForIssueDescription": [
    {
      "type": 0,
      "value": "Try"
    }
  ],
  "jira-xflow-loom.placements.in-app.jira-issueview-description.descriptionForIssueDescription": [
    {
      "type": 0,
      "value": "Use video to explain the work"
    }
  ],
  "jira-xflow-loom.placements.in-app.jira-issueview-description.loom": [
    {
      "type": 0,
      "value": "Loom"
    }
  ],
  "jira-xflow-loom.placements.in-app.jira-issueview-description.titleForIssueDescription": [
    {
      "type": 0,
      "value": "Record your screen"
    }
  ],
  "jira-xflow-loom.placements.in-app.jira-issueview-quickactions.add": [
    {
      "type": 0,
      "value": "Add"
    }
  ],
  "jira-xflow-loom.placements.in-app.jira-issueview-quickactions.video": [
    {
      "type": 0,
      "value": "Video"
    }
  ],
  "jira.default.subject": [
    {
      "type": 0,
      "value": "[JIRA] Project Update: "
    },
    {
      "type": 1,
      "value": "projectName"
    },
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "projectKey"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "jira.jira-bulk.message-template.email.header": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "sent you"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " a message."
    }
  ],
  "jira.jira-bulk.message-template.email.subject.user.provided.subject": [
    {
      "type": 0,
      "value": "[JIRA] "
    },
    {
      "type": 1,
      "value": "subject"
    }
  ],
  "jira.jira-bulk.message-template.text.message": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " sent you a message"
    }
  ],
  "jira.jira-common.email.addon-banner.gmail": [
    {
      "type": 0,
      "value": "Gmail"
    }
  ],
  "jira.jira-common.email.addon-banner.install-text": [
    {
      "type": 0,
      "value": "Install the Atlassian email extension for "
    },
    {
      "type": 1,
      "value": "gmailLink"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "type": 1,
      "value": "outlookLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "jira.jira-common.email.addon-banner.main-text": [
    {
      "type": 0,
      "value": "Update work items without leaving your inbox."
    }
  ],
  "jira.jira-common.email.addon-banner.opt-out": [
    {
      "type": 0,
      "value": "Don't show again"
    }
  ],
  "jira.jira-common.email.addon-banner.outlook": [
    {
      "type": 0,
      "value": "Outlook"
    }
  ],
  "jira.jira-common.email.addon-banner.tip": [
    {
      "type": 0,
      "value": "Tip:"
    }
  ],
  "jira.jira-common.email.dot-separator.no-translate": [
    {
      "type": 0,
      "value": " • "
    }
  ],
  "jira.jira-common.email.footer.custom.message": [
    {
      "type": 1,
      "value": "footerText"
    }
  ],
  "jira.jira-common.email.footer.download.app-store.no-translate": [
    {
      "type": 0,
      "value": "Download on the App Store"
    }
  ],
  "jira.jira-common.email.footer.get-on.google-play.no-translate": [
    {
      "type": 0,
      "value": "Get it on Google Play"
    }
  ],
  "jira.jira-common.email.footer.get.apps": [
    {
      "type": 0,
      "value": "Get Jira notifications on your phone! Download the Jira Cloud app for "
    }
  ],
  "jira.jira-common.email.footer.get.apps.new": [
    {
      "type": 0,
      "value": "Get Jira notifications on your phone! Download the Jira Cloud app for "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Android"
        }
      ],
      "type": 8,
      "value": "a1"
    },
    {
      "type": 0,
      "value": " or "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "iOS"
        }
      ],
      "type": 8,
      "value": "a2"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "jira.jira-common.email.footer.give.feedback": [
    {
      "type": 0,
      "value": "Give feedback"
    }
  ],
  "jira.jira-common.email.footer.manage.notifications": [
    {
      "type": 0,
      "value": "Manage Notifications"
    }
  ],
  "jira.jira-common.email.footer.open.attachment": [
    {
      "type": 0,
      "value": "Open the work item to view attachments over 100 KB"
    }
  ],
  "jira.jira-common.email.footer.privacy.policy": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "jira.jira-common.email.footer.sent-by-atlassian-jira": [
    {
      "type": 0,
      "value": "This email was sent by Atlassian Jira"
    }
  ],
  "jira.jira-common.email.footer.sent.by": [
    {
      "type": 0,
      "value": "This message was sent by Atlassian Jira"
    }
  ],
  "jira.jira-common.email.footer.unsubscribe-message": [
    {
      "type": 0,
      "value": "If you no longer wish to receive these emails, please update your preferences or unsubscribe "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "here"
        }
      ],
      "type": 8,
      "value": "link"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "jira.jira-common.email.loom-footer-tip": [
    {
      "children": [
        {
          "type": 0,
          "value": "Tip:"
        }
      ],
      "type": 8,
      "value": "tip"
    },
    {
      "type": 0,
      "value": " Try "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Loom video"
        }
      ],
      "type": 8,
      "value": "loomVideo"
    },
    {
      "type": 0,
      "value": " to get everyone on the same page, without a meeting."
    }
  ],
  "jira.jira-common.email.slash.no-translate": [
    {
      "type": 0,
      "value": "/"
    }
  ],
  "jira.jira-common.email.twg-cli-banner.link-text": [
    {
      "type": 0,
      "value": "Teamwork Graph CLI"
    }
  ],
  "jira.jira-common.email.twg-cli-banner.text": [
    {
      "type": 0,
      "value": "Give your AI agents rich Jira context with fewer credits. Query open work items and dependencies with "
    },
    {
      "type": 1,
      "value": "twgCliLink"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "jira.jira-common.email.twg-cli-banner.tip": [
    {
      "type": 0,
      "value": "Tip:"
    }
  ],
  "jira.jira-common.message-template.text.body.assignee.label": [
    {
      "type": 0,
      "value": "Assignee:"
    }
  ],
  "jira.jira-common.message-template.text.body.attachments.label": [
    {
      "type": 0,
      "value": "Attachments:"
    }
  ],
  "jira.jira-common.message-template.text.body.key.label": [
    {
      "type": 0,
      "value": "Key:"
    }
  ],
  "jira.jira-common.message-template.text.body.manage.notifications": [
    {
      "type": 0,
      "value": "Manage Notifications"
    }
  ],
  "jira.jira-common.message-template.text.body.priority.label": [
    {
      "type": 0,
      "value": "Priority:"
    }
  ],
  "jira.jira-common.message-template.text.body.project.label": [
    {
      "type": 0,
      "value": "Project:"
    }
  ],
  "jira.jira-common.message-template.text.body.reporter.heading": [
    {
      "type": 0,
      "value": "Reporter: "
    }
  ],
  "jira.jira-common.message-template.text.body.reporter.label": [
    {
      "type": 0,
      "value": "Reporter:"
    }
  ],
  "jira.jira-common.message-template.text.body.sent.by": [
    {
      "type": 0,
      "value": "This message was sent by Atlassian Jira"
    }
  ],
  "jira.jira-common.message-template.text.body.work.type.label": [
    {
      "type": 0,
      "value": "Work type:"
    }
  ],
  "jira.jira-filter-subscription.message-template.email.table.filter-label": [
    {
      "type": 0,
      "value": "Filter: "
    }
  ],
  "jira.jira-filter-subscription.message-template.email.table.header": [
    {
      "type": 0,
      "value": "Work Item Subscription"
    }
  ],
  "jira.jira-filter-subscription.message-template.email.table.subscriber-label": [
    {
      "type": 0,
      "value": "Subscriber:"
    }
  ],
  "jira.jira-issue-approval-decided.message-template.approval.by.user": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " has approved "
    },
    {
      "type": 1,
      "value": "issueLink"
    }
  ],
  "jira.jira-issue-approval-decided.message-template.approval.event.allapproved.transition": [
    {
      "type": 1,
      "value": "issueTypeName"
    },
    {
      "type": 0,
      "value": " has moved from "
    },
    {
      "type": 1,
      "value": "originalStatus"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "arrowIcon"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "newStatus"
    }
  ],
  "jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.plural": [
    {
      "type": 1,
      "value": "remainingApprovals"
    },
    {
      "type": 0,
      "value": " more approvals required to move this "
    },
    {
      "type": 1,
      "value": "issueTypeName"
    },
    {
      "type": 0,
      "value": " from "
    },
    {
      "type": 1,
      "value": "originalStatus"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "arrowIcon"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "newStatus"
    }
  ],
  "jira.jira-issue-approval-decided.message-template.approval.event.approved.transition.singular": [
    {
      "type": 0,
      "value": "1 more approval required to move this "
    },
    {
      "type": 1,
      "value": "issueTypeName"
    },
    {
      "type": 0,
      "value": " from "
    },
    {
      "type": 1,
      "value": "originalStatus"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "arrowIcon"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "newStatus"
    }
  ],
  "jira.jira-issue-approval-decided.message-template.approval.event.declined.transition": [
    {
      "type": 1,
      "value": "issueTypeName"
    },
    {
      "type": 0,
      "value": " has moved from "
    },
    {
      "type": 1,
      "value": "originalStatus"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "arrowIcon"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "newStatus"
    }
  ],
  "jira.jira-issue-approval-decided.message-template.declined.by.user": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " has declined "
    },
    {
      "type": 1,
      "value": "issueLink"
    }
  ],
  "jira.jira-issue-approval.message-template.approval.required.title": [
    {
      "type": 1,
      "value": "issueLabel"
    },
    {
      "type": 0,
      "value": " requires your approval"
    }
  ],
  "jira.jira-issue-approval.message-template.approval.title.all-approved": [
    {
      "type": 1,
      "value": "issueLink"
    },
    {
      "type": 0,
      "value": " has been approved!"
    }
  ],
  "jira.jira-issue-approval.message-template.email.approval.approved": [
    {
      "type": 0,
      "value": "Approved"
    }
  ],
  "jira.jira-issue-approval.message-template.email.approval.approvers.remaining": [
    {
      "type": 1,
      "value": "remainingApprovers"
    },
    {
      "type": 0,
      "value": " more approvals required to move this "
    },
    {
      "type": 1,
      "value": "issueType"
    },
    {
      "type": 0,
      "value": " from "
    },
    {
      "type": 1,
      "value": "originalStatus"
    },
    {
      "type": 0,
      "value": " to "
    },
    {
      "type": 1,
      "value": "approvedStatus"
    }
  ],
  "jira.jira-issue-approval.message-template.email.approval.assigned.to": [
    {
      "type": 0,
      "value": "Assigned to: "
    },
    {
      "type": 1,
      "value": "assignee"
    }
  ],
  "jira.jira-issue-approval.message-template.email.approval.declined": [
    {
      "type": 0,
      "value": "Declined"
    }
  ],
  "jira.jira-issue-approval.message-template.email.approval.declined.transition": [
    {
      "type": 1,
      "value": "issueType"
    },
    {
      "type": 0,
      "value": " has moved from "
    },
    {
      "type": 1,
      "value": "originalStatus"
    },
    {
      "type": 0,
      "value": " to "
    },
    {
      "type": 1,
      "value": "declinedStatus"
    }
  ],
  "jira.jira-issue-approval.message-template.email.approval.event.approvers": [
    {
      "type": 0,
      "value": "Approvers: "
    }
  ],
  "jira.jira-issue-approval.message-template.email.approval.one.approver.remaining": [
    {
      "type": 0,
      "value": "1 more approval required to move this "
    },
    {
      "type": 1,
      "value": "issueType"
    },
    {
      "type": 0,
      "value": " from "
    },
    {
      "type": 1,
      "value": "originalStatus"
    },
    {
      "type": 0,
      "value": " to "
    },
    {
      "type": 1,
      "value": "approvedStatus"
    }
  ],
  "jira.jira-issue-approval.message-template.email.approval.view.work.item": [
    {
      "type": 0,
      "value": "View "
    },
    {
      "type": 1,
      "value": "issueType"
    }
  ],
  "jira.jira-issue-approval.message-template.email.approved.by": [
    {
      "type": 1,
      "value": "deciderName"
    },
    {
      "type": 0,
      "value": " has approved "
    },
    {
      "type": 1,
      "value": "issueLabel"
    }
  ],
  "jira.jira-issue-approval.message-template.email.declined.by": [
    {
      "type": 1,
      "value": "deciderName"
    },
    {
      "type": 0,
      "value": " has declined "
    },
    {
      "type": 1,
      "value": "issueLabel"
    }
  ],
  "jira.jira-issue-approval.message-template.email.footer.contact.us": [
    {
      "type": 0,
      "value": "Contact Us"
    }
  ],
  "jira.jira-issue-approval.message-template.email.footer.location": [
    {
      "type": 0,
      "value": "We are located at 341 George Street, Sydney, NSW, 2000, Australia."
    }
  ],
  "jira.jira-issue-approval.message-template.email.footer.privacy.policy": [
    {
      "type": 0,
      "value": "Privacy Policy"
    }
  ],
  "jira.jira-issue-approval.message-template.email.issue.approved": [
    {
      "type": 1,
      "value": "issueLabel"
    },
    {
      "type": 0,
      "value": " has been approved!"
    }
  ],
  "jira.jira-issue-approval.message-template.email.issue.has.moved.from": [
    {
      "type": 1,
      "value": "issueType"
    },
    {
      "type": 0,
      "value": " has moved from "
    },
    {
      "type": 1,
      "value": "originalStatus"
    },
    {
      "type": 0,
      "value": " to "
    },
    {
      "type": 1,
      "value": "approvedStatus"
    }
  ],
  "jira.jira-issue-archived.message-template.email.subject": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "archived a work item."
        }
      ],
      "type": 8,
      "value": "strong"
    }
  ],
  "jira.jira-issue-archived.message-template.redacted.email.subject": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "archived a work item."
        }
      ],
      "type": 8,
      "value": "strong"
    }
  ],
  "jira.jira-issue-archived.message-template.text.archived.work.item": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " archived "
    },
    {
      "type": 1,
      "value": "workItemKey"
    },
    {
      "type": 0,
      "value": ":"
    }
  ],
  "jira.jira-issue-assign.text.body.assigned": [
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " reassigned "
    },
    {
      "type": 1,
      "value": "issueKey"
    }
  ],
  "jira.jira-issue-assign.text.body.assignee.update": [
    {
      "type": 0,
      "value": "Assignee: "
    },
    {
      "type": 1,
      "value": "assigneeName"
    },
    {
      "type": 0,
      "value": " was: ("
    },
    {
      "type": 1,
      "value": "oldAssigneeName"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "jira.jira-issue-assign.text.body.sentby": [
    {
      "type": 0,
      "value": "This message was sent by Atlassian Jira"
    }
  ],
  "jira.jira-issue-batch.email.body.issue.comments.heading": [
    {
      "type": 0,
      "value": "Comments"
    }
  ],
  "jira.jira-issue-batch.email.body.issue.created.heading": [
    {
      "type": 0,
      "value": "Work item created"
    }
  ],
  "jira.jira-issue-batch.email.body.issue.updates.heading": [
    {
      "type": 0,
      "value": "Updates"
    }
  ],
  "jira.jira-issue-batch.email.body.issue.worklog.heading": [
    {
      "type": 0,
      "value": "Work log"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.comment.created.heading": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " added a new comment"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": "  added "
                },
                {
                  "type": 1,
                  "value": "count"
                },
                {
                  "type": 0,
                  "value": " new comments"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.comment.created.more.heading": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "userCount"
    },
    {
      "type": 0,
      "value": " other people "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "  added "
        },
        {
          "type": 1,
          "value": "count"
        },
        {
          "type": 0,
          "value": " new comments"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.comment.created.two.heading": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "user2"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "  added "
        },
        {
          "type": 1,
          "value": "count"
        },
        {
          "type": 0,
          "value": " new comments"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.comment.deleted.heading": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " deleted a comment"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": "  deleted "
                },
                {
                  "type": 1,
                  "value": "count"
                },
                {
                  "type": 0,
                  "value": " comments"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.comment.deleted.more.heading": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "userCount"
    },
    {
      "type": 0,
      "value": " other people "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "  deleted "
        },
        {
          "type": 1,
          "value": "count"
        },
        {
          "type": 0,
          "value": " comments"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.comment.deleted.two.heading": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "user2"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "  deleted "
        },
        {
          "type": 1,
          "value": "count"
        },
        {
          "type": 0,
          "value": " comments"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.comment.updated.heading": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " updated a comment"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": "  updated "
                },
                {
                  "type": 1,
                  "value": "count"
                },
                {
                  "type": 0,
                  "value": " comments"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.comment.updated.more.heading": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "userCount"
    },
    {
      "type": 0,
      "value": " other people "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "  updated "
        },
        {
          "type": 1,
          "value": "count"
        },
        {
          "type": 0,
          "value": " comments"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.comment.updated.two.heading": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "user2"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "  updated "
        },
        {
          "type": 1,
          "value": "count"
        },
        {
          "type": 0,
          "value": " comments"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.created.heading": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "created a work item"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.deleted.heading": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " deleted a work item"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": "  deleted "
                },
                {
                  "type": 1,
                  "value": "count"
                },
                {
                  "type": 0,
                  "value": " work items"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.dot": [
    {
      "type": 0,
      "value": ". "
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.fallback.heading": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " made an update"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " made "
                },
                {
                  "type": 1,
                  "value": "count"
                },
                {
                  "type": 0,
                  "value": " updates"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.fallback.more.heading": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 1,
              "value": "user1"
            },
            {
              "type": 0,
              "value": " and "
            },
            {
              "type": 1,
              "value": "userCount"
            },
            {
              "type": 0,
              "value": " other people "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " made an update"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 1,
              "value": "user1"
            },
            {
              "type": 0,
              "value": " and "
            },
            {
              "type": 1,
              "value": "userCount"
            },
            {
              "type": 0,
              "value": " other people "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " made "
                },
                {
                  "type": 1,
                  "value": "count"
                },
                {
                  "type": 0,
                  "value": " updates"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.fallback.two.heading": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 1,
              "value": "user1"
            },
            {
              "type": 0,
              "value": " and "
            },
            {
              "type": 1,
              "value": "user2"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " made an update"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 1,
              "value": "user1"
            },
            {
              "type": 0,
              "value": " and "
            },
            {
              "type": 1,
              "value": "user2"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " made "
                },
                {
                  "type": 1,
                  "value": "count"
                },
                {
                  "type": 0,
                  "value": " updates"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.separator.comma": [
    {
      "type": 0,
      "value": ", "
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.updates.heading": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "type": 1,
              "value": "count"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " made an update"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": "  made "
                },
                {
                  "type": 1,
                  "value": "count"
                },
                {
                  "type": 0,
                  "value": " updates"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.updates.multiple.users.heading": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " other person"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " other people"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "userCount"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "  made "
        },
        {
          "offset": 0,
          "options": {
            "one": {
              "value": [
                {
                  "type": 0,
                  "value": "an update"
                }
              ]
            },
            "other": {
              "value": [
                {
                  "type": 1,
                  "value": "count"
                },
                {
                  "type": 0,
                  "value": " updates"
                }
              ]
            }
          },
          "pluralType": "cardinal",
          "type": 6,
          "value": "count"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.updates.two.users.heading": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "  made "
        },
        {
          "offset": 0,
          "options": {
            "one": {
              "value": [
                {
                  "type": 0,
                  "value": "an update"
                }
              ]
            },
            "other": {
              "value": [
                {
                  "type": 1,
                  "value": "count"
                },
                {
                  "type": 0,
                  "value": " updates"
                }
              ]
            }
          },
          "pluralType": "cardinal",
          "type": 6,
          "value": "count"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.worklog.added.heading": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " added a worklog"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": "  added "
                },
                {
                  "type": 1,
                  "value": "count"
                },
                {
                  "type": 0,
                  "value": " work log"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.worklog.added.more.heading": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "userCount"
    },
    {
      "type": 0,
      "value": " other people "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "  added "
        },
        {
          "type": 1,
          "value": "count"
        },
        {
          "type": 0,
          "value": " work log"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.worklog.added.two.heading": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "user2"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "  added "
        },
        {
          "type": 1,
          "value": "count"
        },
        {
          "type": 0,
          "value": " work log"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.heading": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " deleted a worklog"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": "  deleted "
                },
                {
                  "type": 1,
                  "value": "count"
                },
                {
                  "type": 0,
                  "value": " work log"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.more.heading": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "userCount"
    },
    {
      "type": 0,
      "value": " other people "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "  deleted "
        },
        {
          "type": 1,
          "value": "count"
        },
        {
          "type": 0,
          "value": " work log"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.worklog.deleted.two.heading": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "user2"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "  deleted "
        },
        {
          "type": 1,
          "value": "count"
        },
        {
          "type": 0,
          "value": " work log"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.worklog.started.heading": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " started a worklog"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": "  started "
                },
                {
                  "type": 1,
                  "value": "count"
                },
                {
                  "type": 0,
                  "value": " work log"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.worklog.started.more.heading": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "userCount"
    },
    {
      "type": 0,
      "value": " other people "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "  started "
        },
        {
          "type": 1,
          "value": "count"
        },
        {
          "type": 0,
          "value": " work log"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.worklog.started.two.heading": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "user2"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "  started "
        },
        {
          "type": 1,
          "value": "count"
        },
        {
          "type": 0,
          "value": " work log"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.worklog.updated.heading": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " updated a worklog"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": "  updated "
                },
                {
                  "type": 1,
                  "value": "count"
                },
                {
                  "type": 0,
                  "value": " work log"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.worklog.updated.more.heading": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "userCount"
    },
    {
      "type": 0,
      "value": " other people "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "  updated "
        },
        {
          "type": 1,
          "value": "count"
        },
        {
          "type": 0,
          "value": " work log"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira.jira-issue-batch.email.body.summary.issue.worklog.updated.two.heading": [
    {
      "type": 1,
      "value": "user1"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "type": 1,
      "value": "user2"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "  updated "
        },
        {
          "type": 1,
          "value": "count"
        },
        {
          "type": 0,
          "value": " work log"
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.heading": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " made an update"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 1,
              "value": "user"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " made "
                },
                {
                  "type": 1,
                  "value": "count"
                },
                {
                  "type": 0,
                  "value": " updates"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.more.heading": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 1,
              "value": "user1"
            },
            {
              "type": 0,
              "value": " and "
            },
            {
              "type": 1,
              "value": "userCount"
            },
            {
              "type": 0,
              "value": " other people "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " made an update"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 1,
              "value": "user1"
            },
            {
              "type": 0,
              "value": " and "
            },
            {
              "type": 1,
              "value": "userCount"
            },
            {
              "type": 0,
              "value": " other people "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " made "
                },
                {
                  "type": 1,
                  "value": "count"
                },
                {
                  "type": 0,
                  "value": " updates"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "jira.jira-issue-batch.email.unredacted.body.summary.issue.fallback.two.heading": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 1,
              "value": "user1"
            },
            {
              "type": 0,
              "value": " and "
            },
            {
              "type": 1,
              "value": "user2"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " made an update"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 1,
              "value": "user1"
            },
            {
              "type": 0,
              "value": " and "
            },
            {
              "type": 1,
              "value": "user2"
            },
            {
              "type": 0,
              "value": " "
            },
            {
              "children": [
                {
                  "type": 0,
                  "value": " made "
                },
                {
                  "type": 1,
                  "value": "count"
                },
                {
                  "type": 0,
                  "value": " updates"
                }
              ],
              "type": 8,
              "value": "b"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "count"
    }
  ],
  "jira.jira-issue-batch.message-template.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] ("
    },
    {
      "type": 1,
      "value": "issueId"
    },
    {
      "type": 0,
      "value": ") "
    },
    {
      "type": 1,
      "value": "summary"
    }
  ],
  "jira.jira-issue-batch.message-template.redacted.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] Updates for "
    },
    {
      "type": 1,
      "value": "issueId"
    }
  ],
  "jira.jira-issue-closed.message-template.email.body.closed": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "closed a work item"
        }
      ],
      "type": 8,
      "value": "strong"
    }
  ],
  "jira.jira-issue-closed.message-template.email.body.closed.redesigned": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "closed a work item"
        }
      ],
      "type": 8,
      "value": "strong"
    }
  ],
  "jira.jira-issue-closed.message-template.text.email.body": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " closed "
    },
    {
      "type": 1,
      "value": "workItemKey"
    }
  ],
  "jira.jira-issue-comment-delete.message-template.email.body.commented": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "deleted a comment on a work item"
        }
      ],
      "type": 8,
      "value": "strong"
    }
  ],
  "jira.jira-issue-comment-delete.message-template.text.comment.was.deleted": [
    {
      "type": 0,
      "value": "Comment: was deleted"
    }
  ],
  "jira.jira-issue-comment-delete.message-template.text.updated.work.item": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " updated "
    },
    {
      "type": 1,
      "value": "workItemKey"
    },
    {
      "type": 0,
      "value": ":"
    }
  ],
  "jira.jira-issue-comment-update.message-template.email.body.commented": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "edited a comment on a work item"
        }
      ],
      "type": 8,
      "value": "strong"
    }
  ],
  "jira.jira-issue-comment-update.message-template.text.body.comment.was": [
    {
      "type": 0,
      "value": "was (Author: "
    },
    {
      "type": 1,
      "value": "authorName"
    },
    {
      "type": 0,
      "value": "):"
    }
  ],
  "jira.jira-issue-comment-update.message-template.text.subject": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " edited a comment on "
    },
    {
      "type": 1,
      "value": "workItemKey"
    }
  ],
  "jira.jira-issue-comment.message-template.email.body.commented": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "added a comment on a work item"
        }
      ],
      "type": 8,
      "value": "strong"
    }
  ],
  "jira.jira-issue-comment.message-template.text.subject": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " commented on "
    },
    {
      "type": 1,
      "value": "workItemKey"
    },
    {
      "type": 0,
      "value": ":"
    }
  ],
  "jira.jira-issue-common.message-template.text.body.common.author": [
    {
      "type": 0,
      "value": "Author:"
    }
  ],
  "jira.jira-issue-common.message-template.text.body.common.issue.author": [
    {
      "type": 0,
      "value": "Author:"
    }
  ],
  "jira.jira-issue-create.email.body.created": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "created a work item"
        }
      ],
      "type": 8,
      "value": "strong"
    }
  ],
  "jira.jira-issue-create.email.body.view.attachments": [
    {
      "type": 0,
      "value": "View Attachments"
    }
  ],
  "jira.jira-issue-create.email.body.view.components": [
    {
      "type": 0,
      "value": "View Components"
    }
  ],
  "jira.jira-issue-create.email.body.view.description": [
    {
      "type": 0,
      "value": "View description"
    }
  ],
  "jira.jira-issue-create.email.body.view.environment": [
    {
      "type": 0,
      "value": "View environment"
    }
  ],
  "jira.jira-issue-create.email.body.view.labels": [
    {
      "type": 0,
      "value": "View labels"
    }
  ],
  "jira.jira-issue-create.email.body.view.work.type": [
    {
      "type": 0,
      "value": "View Work Type"
    }
  ],
  "jira.jira-issue-create.message-template.email.original.subject": [
    {
      "type": 0,
      "value": "[JIRA] ("
    },
    {
      "type": 1,
      "value": "issueKey"
    },
    {
      "type": 0,
      "value": ") "
    },
    {
      "type": 1,
      "value": "summary"
    }
  ],
  "jira.jira-issue-create.message-template.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " created "
    },
    {
      "type": 1,
      "value": "issueKey"
    }
  ],
  "jira.jira-issue-create.message-template.text.body.common.issue.key": [
    {
      "type": 0,
      "value": "Key"
    }
  ],
  "jira.jira-issue-create.message-template.text.body.common.summary": [
    {
      "type": 0,
      "value": "Summary"
    }
  ],
  "jira.jira-issue-create.message-template.text.email.body.created": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " created a work item"
    }
  ],
  "jira.jira-issue-create.text.body.common.assignee": [
    {
      "type": 0,
      "value": "Assignee"
    }
  ],
  "jira.jira-issue-create.text.body.common.attachments": [
    {
      "type": 0,
      "value": "Attachments"
    }
  ],
  "jira.jira-issue-create.text.body.common.created": [
    {
      "type": 0,
      "value": "Created"
    }
  ],
  "jira.jira-issue-create.text.body.common.description": [
    {
      "type": 0,
      "value": "Description"
    }
  ],
  "jira.jira-issue-create.text.body.common.priority": [
    {
      "type": 0,
      "value": "Priority"
    }
  ],
  "jira.jira-issue-create.text.body.common.reporter": [
    {
      "type": 0,
      "value": "Reporter"
    }
  ],
  "jira.jira-issue-create.text.body.common.status": [
    {
      "type": 0,
      "value": "Status"
    }
  ],
  "jira.jira-issue-create.text.body.common.work.type": [
    {
      "type": 0,
      "value": "Work type"
    }
  ],
  "jira.jira-issue-delete.message-template.email.body.workitem.deleted": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " deleted this work item at "
    },
    {
      "type": 1,
      "value": "timestamp"
    }
  ],
  "jira.jira-issue-delete.message-template.redacted.email.body.workitem.deleted": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "deleted"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " a work item"
    }
  ],
  "jira.jira-issue-delete.message-template.text.deleted.work.item": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " deleted "
    },
    {
      "type": 1,
      "value": "workItemKey"
    },
    {
      "type": 0,
      "value": ":"
    }
  ],
  "jira.jira-issue-filter-subscription.message-template.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] Subscription: "
    },
    {
      "type": 1,
      "value": "filterName"
    }
  ],
  "jira.jira-issue-filter-subscription.message-template.text.email.body.header": [
    {
      "type": 0,
      "value": "Work Item Subscription"
    }
  ],
  "jira.jira-issue-filter-subscription.message-template.text.email.body.header.filter-name": [
    {
      "type": 0,
      "value": "Filter: "
    },
    {
      "type": 1,
      "value": "filterName"
    },
    {
      "type": 1,
      "value": "count"
    }
  ],
  "jira.jira-issue-filter-subscription.message-template.text.email.body.header.subscriber-info": [
    {
      "type": 0,
      "value": "Subscriber: "
    },
    {
      "type": 1,
      "value": "subscriberName"
    }
  ],
  "jira.jira-issue-mention.email.body.colon.no-translate": [
    {
      "type": 0,
      "value": ": "
    }
  ],
  "jira.jira-issue-mention.email.body.created": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "mentioned you"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " on a work item"
    }
  ],
  "jira.jira-issue-mention.email.body.mentioned.you": [
    {
      "type": 0,
      "value": " mentioned you "
    }
  ],
  "jira.jira-issue-mention.email.body.onWorkItem.you": [
    {
      "type": 0,
      "value": " on a work item "
    }
  ],
  "jira.jira-issue-mention.email.body.spaces.no-translate": [
    {
      "type": 0,
      "value": "&nbsp;&nbsp;"
    }
  ],
  "jira.jira-issue-mention.email.body.view.work.item": [
    {
      "type": 0,
      "value": " View work item "
    }
  ],
  "jira.jira-issue-mention.email.subject.mention": [
    {
      "type": 0,
      "value": "[JIRA] "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " mentioned you on "
    },
    {
      "type": 1,
      "value": "issueKey"
    }
  ],
  "jira.jira-issue-mention.push.mentioned.you": [
    {
      "type": 0,
      "value": "📣 "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " mentioned you on "
    },
    {
      "type": 1,
      "value": "summary"
    }
  ],
  "jira.jira-issue-mention.push.mentioned.you.redacted": [
    {
      "type": 0,
      "value": "📣 "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " mentioned you on this work item"
    }
  ],
  "jira.jira-issue-mention.text.body.addComment": [
    {
      "type": 0,
      "value": " Add Comment: "
    }
  ],
  "jira.jira-issue-mention.text.body.manage.notifications": [
    {
      "type": 0,
      "value": "Manage Notifications"
    }
  ],
  "jira.jira-issue-mention.text.body.mention.hint": [
    {
      "type": 0,
      "value": " Hint: You can mention someone in a work item description or comment by typing  \"@\" in front of their username."
    }
  ],
  "jira.jira-issue-mention.text.body.mentioned": [
    {
      "type": 0,
      "value": " mentioned you on "
    }
  ],
  "jira.jira-issue-mention.text.body.sentby": [
    {
      "type": 0,
      "value": "This message was sent by Atlassian Jira"
    }
  ],
  "jira.jira-issue-mention.text.body.unassigned": [
    {
      "type": 0,
      "value": "Unassigned"
    }
  ],
  "jira.jira-issue-mention.text.body.viewOnline": [
    {
      "type": 0,
      "value": " View Online: "
    }
  ],
  "jira.jira-issue-moved.message-template.email.body.created": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "moved a work item"
        }
      ],
      "type": 8,
      "value": "strong"
    }
  ],
  "jira.jira-issue-moved.message-template.text.email.body": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " moved "
    },
    {
      "type": 1,
      "value": "workItemKey"
    }
  ],
  "jira.jira-issue-notify.email.body.heading": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "shared"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " a work item with you"
    }
  ],
  "jira.jira-issue-notify.email.body.heading.redesigned": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "shared"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " a work item with you"
    }
  ],
  "jira.jira-issue-notify.email.subject.notify": [
    {
      "type": 0,
      "value": "[JIRA] "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " shared \""
    },
    {
      "type": 1,
      "value": "issueKey"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "summary"
    },
    {
      "type": 0,
      "value": "\" with you"
    }
  ],
  "jira.jira-issue-reopened.message-template.email.body.reopened": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "reopened a work item"
        }
      ],
      "type": 8,
      "value": "strong"
    }
  ],
  "jira.jira-issue-reopened.message-template.text.subject": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " reopened "
    },
    {
      "type": 1,
      "value": "workItemKey"
    }
  ],
  "jira.jira-issue-resolved.message-template.text.subject": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " resolved "
    },
    {
      "type": 1,
      "value": "workItemKey"
    }
  ],
  "jira.jira-issue-search.message-template.email.subject.filter.results": [
    {
      "type": 0,
      "value": "[JIRA] "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " shared the filter \""
    },
    {
      "type": 1,
      "value": "filterName"
    },
    {
      "type": 0,
      "value": "\" with you"
    }
  ],
  "jira.jira-issue-search.message-template.email.subject.search.results": [
    {
      "type": 0,
      "value": "[JIRA] "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " shared a search result with you"
    }
  ],
  "jira.jira-issue-share.message-template.email.header.filter": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "shared"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " a filter with you."
    }
  ],
  "jira.jira-issue-share.message-template.email.header.results": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "shared"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " a search result with you."
    }
  ],
  "jira.jira-issue-share.message-template.email.shared-with": [
    {
      "type": 0,
      "value": " Also shared with "
    }
  ],
  "jira.jira-issue-share.message-template.email.view.results": [
    {
      "type": 0,
      "value": "View search results"
    }
  ],
  "jira.jira-issue-share.message-template.text.shared.filter.heading": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " shared a filter with you"
    }
  ],
  "jira.jira-issue-share.message-template.text.shared.results.heading": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " shared a search result with you"
    }
  ],
  "jira.jira-issue-share.message-template.text.shared.with.others": [
    {
      "type": 0,
      "value": "Also shared with"
    }
  ],
  "jira.jira-issue-test.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "[JIRA] test template "
    },
    {
      "type": 1,
      "value": "issueKey"
    }
  ],
  "jira.jira-issue-update.message-template.email.body.created": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "updated a work item"
        }
      ],
      "type": 8,
      "value": "strong"
    }
  ],
  "jira.jira-issue-update.message-template.email.body.created.redesigned": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "updated a work item"
        }
      ],
      "type": 8,
      "value": "strong"
    }
  ],
  "jira.jira-issue-update.message-template.email.body.worklog.change.by": [
    {
      "type": 0,
      "value": "Change by: "
    }
  ],
  "jira.jira-issue-update.message-template.text.subject": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " updated "
    },
    {
      "type": 1,
      "value": "workItemKey"
    }
  ],
  "jira.jira-issue-work-started.message-template.email.body.created": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "made "
        },
        {
          "offset": 0,
          "options": {
            "one": {
              "value": [
                {
                  "type": 7
                },
                {
                  "type": 0,
                  "value": " update"
                }
              ]
            },
            "other": {
              "value": [
                {
                  "type": 7
                },
                {
                  "type": 0,
                  "value": " updates"
                }
              ]
            }
          },
          "pluralType": "cardinal",
          "type": 6,
          "value": "numberOfUpdates"
        }
      ],
      "type": 8,
      "value": "strong"
    }
  ],
  "jira.jira-issue-work-started.message-template.email.body.created.redesigned": [
    {
      "type": 1,
      "value": "actioner"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "made "
        },
        {
          "offset": 0,
          "options": {
            "one": {
              "value": [
                {
                  "type": 7
                },
                {
                  "type": 0,
                  "value": " update"
                }
              ]
            },
            "other": {
              "value": [
                {
                  "type": 7
                },
                {
                  "type": 0,
                  "value": " updates"
                }
              ]
            }
          },
          "pluralType": "cardinal",
          "type": 6,
          "value": "numberOfUpdates"
        }
      ],
      "type": 8,
      "value": "strong"
    }
  ],
  "jira.jira-issue-work-started.message-template.text.header": [
    {
      "type": 0,
      "value": "Work on "
    },
    {
      "type": 1,
      "value": "workItemKey"
    },
    {
      "type": 0,
      "value": " started by "
    },
    {
      "type": 1,
      "value": "user"
    }
  ],
  "jira.jira-issue-work-stopped.message-template.text.header": [
    {
      "type": 0,
      "value": "Work on "
    },
    {
      "type": 1,
      "value": "workItemKey"
    },
    {
      "type": 0,
      "value": " stopped by "
    },
    {
      "type": 1,
      "value": "user"
    }
  ],
  "jira.jira-issue-worklog-delete.message-template.email.body.title.redesigned": [
    {
      "children": [
        {
          "type": 0,
          "value": " made 2 updates"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "edited 1 work log"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "jira.jira-issue-worklog-delete.message-template.email.redacted.body.title": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "deleted a worklog"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " on a work item"
    }
  ],
  "jira.jira-issue-worklog-deleted.message-template.text.email.body.deleted.worklog": [
    {
      "type": 0,
      "value": "The following worklog was deleted:"
    }
  ],
  "jira.jira-issue-worklog-update.message-template.email.body.title": [
    {
      "children": [
        {
          "type": 0,
          "value": " made 2 updates"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "edited 1 work log"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "jira.jira-issue-worklog-update.message-template.email.body.title.redesigned": [
    {
      "children": [
        {
          "type": 0,
          "value": " made 2 updates"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "edited 1 work log"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "jira.jira-issue-worklog-update.message-template.email.redacted.body.title": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "updated a worklog"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " on a work item"
    }
  ],
  "jira.jira-issue-worklog-updated.message-template.email.body.description": [
    {
      "type": 0,
      "value": "Description"
    }
  ],
  "jira.jira-issue-worklog-updated.message-template.email.body.timeLogged": [
    {
      "type": 0,
      "value": "Time logged"
    }
  ],
  "jira.jira-issue-worklogged.message-template.email.body.description": [
    {
      "type": 0,
      "value": "Description: "
    }
  ],
  "jira.jira-issue-worklogged.message-template.email.body.logTitle": [
    {
      "type": 0,
      "value": "Work log"
    }
  ],
  "jira.jira-issue-worklogged.message-template.email.body.timelogged": [
    {
      "type": 0,
      "value": "Time logged: "
    }
  ],
  "jira.jira-issue-worklogged.message-template.email.body.title": [
    {
      "children": [
        {
          "type": 0,
          "value": " made 2 updates"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "added 1 work log"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "jira.jira-issue-worklogged.message-template.email.body.updateTitle": [
    {
      "type": 0,
      "value": "Updates"
    }
  ],
  "jira.jira-issue-worklogged.message-template.email.body.worklog.change.by": [
    {
      "type": 0,
      "value": "Change by: "
    }
  ],
  "jira.jira-issue-worklogged.message-template.email.body.worklog.entry": [
    {
      "type": 0,
      "value": "Worklog entry:"
    }
  ],
  "jira.jira-issue-worklogged.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "[JIRA] "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " logged work on "
    },
    {
      "type": 1,
      "value": "issueKey"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.body.common.change.by": [
    {
      "type": 0,
      "value": "Change by"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.body.common.issue.created.on": [
    {
      "type": 0,
      "value": "Created on:"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.by": [
    {
      "type": 0,
      "value": "Edited by:"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.body.common.issue.edited.on": [
    {
      "type": 0,
      "value": "Edited on:"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.body.common.issue.key": [
    {
      "type": 0,
      "value": "Key:"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.body.common.issue.worklog.entry.label": [
    {
      "type": 0,
      "value": "Worklog entry"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.body.common.project": [
    {
      "type": 0,
      "value": "Project:"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.body.common.start.date": [
    {
      "type": 0,
      "value": "Start Date:"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.body.common.time.spent": [
    {
      "type": 0,
      "value": "Time Spent:"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.body.common.url": [
    {
      "type": 0,
      "value": "URL:"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.body.common.view.work.description": [
    {
      "type": 0,
      "value": "View work description"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.body.common.work.type": [
    {
      "type": 0,
      "value": "Work type:"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.body.common.worklog.body": [
    {
      "type": 0,
      "value": "Work Description:"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.body.common.worklog.description": [
    {
      "type": 0,
      "value": "Worklog Description:"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.body.common.worklog.description.was": [
    {
      "type": 0,
      "value": "Worklog Description was:"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.body.common.worklog.id": [
    {
      "type": 0,
      "value": "Worklog Id:"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.estimated": [
    {
      "type": 0,
      "value": "Remaining Estimate:"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.body.common.worklog.time.spent": [
    {
      "type": 0,
      "value": "Worklog Time Spent:"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.body.redacted.logged.by": [
    {
      "type": 1,
      "value": "worklogEntry"
    },
    {
      "type": 0,
      "value": " logged by "
    },
    {
      "type": 1,
      "value": "actioner"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.email.body.created": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " logged work on "
    },
    {
      "type": 1,
      "value": "issueKey"
    }
  ],
  "jira.jira-issue-worklogged.message-template.text.email.body.tracking": [
    {
      "type": 0,
      "value": "Issue time Tracking"
    }
  ],
  "jira.jira-project-deletion-reminder.message-template.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] "
    },
    {
      "type": 1,
      "value": "header"
    },
    {
      "type": 0,
      "value": " "
    }
  ],
  "jira.jira-project-event-archived-restore.message-template.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] ("
    },
    {
      "type": 1,
      "value": "projectName"
    },
    {
      "type": 0,
      "value": ") ("
    },
    {
      "type": 1,
      "value": "projectKey"
    },
    {
      "type": 0,
      "value": ") Project restored from archive "
    }
  ],
  "jira.jira-project-event-archived.message-template.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] ("
    },
    {
      "type": 1,
      "value": "projectName"
    },
    {
      "type": 0,
      "value": ") ("
    },
    {
      "type": 1,
      "value": "projectKey"
    },
    {
      "type": 0,
      "value": ") Space archived"
    }
  ],
  "jira.jira-project-event-delete-failed.message-template.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] ("
    },
    {
      "type": 1,
      "value": "projectName"
    },
    {
      "type": 0,
      "value": ") ("
    },
    {
      "type": 1,
      "value": "projectKey"
    },
    {
      "type": 0,
      "value": ") Could not permanently delete the project "
    }
  ],
  "jira.jira-project-event-deleted-restore.message-template.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] ("
    },
    {
      "type": 1,
      "value": "projectName"
    },
    {
      "type": 0,
      "value": ") ("
    },
    {
      "type": 1,
      "value": "projectKey"
    },
    {
      "type": 0,
      "value": ") Project restored from trash"
    }
  ],
  "jira.jira-project-event-deleted.message-template.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] ("
    },
    {
      "type": 1,
      "value": "projectName"
    },
    {
      "type": 0,
      "value": ") ("
    },
    {
      "type": 1,
      "value": "projectKey"
    },
    {
      "type": 0,
      "value": ") Project moved to trash"
    }
  ],
  "jira.jira-project-event-user-invited-new-user.message-template.email.subject": [
    {
      "type": 0,
      "value": "Action requested: "
    },
    {
      "type": 1,
      "value": "userName"
    },
    {
      "type": 0,
      "value": " invited you to join your team in "
    },
    {
      "type": 1,
      "value": "projectName"
    },
    {
      "type": 0,
      "value": ", Jira"
    }
  ],
  "jira.jira-project-event-user-invited-new-user.message-template.email.subject.redacted": [
    {
      "type": 0,
      "value": "Action requested: You've been invited to join your team in Jira"
    }
  ],
  "jira.jira-project-event-user-invited.message-template.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] ("
    },
    {
      "type": 1,
      "value": "userName"
    },
    {
      "type": 0,
      "value": ") invited you to ("
    },
    {
      "type": 1,
      "value": "projectName"
    },
    {
      "type": 0,
      "value": ")  "
    }
  ],
  "jira.lovabilityFastSnappy.survey.fast-and-snappy.statement": [
    {
      "type": 0,
      "value": "Jira feels fast and snappy"
    }
  ],
  "jira.lovabilityFastSnappy.survey.lovability.statement": [
    {
      "type": 0,
      "value": "Jira is a pleasure to use"
    }
  ],
  "jira.lovabilityFastSnappy.survey.overline": [
    {
      "type": 0,
      "value": "To what extent do you agree or disagree with the following statement?"
    }
  ],
  "jira.lovabilityFastSnappy.survey.score-subtext.neutral": [
    {
      "type": 0,
      "value": "Neutral"
    }
  ],
  "jira.lovabilityFastSnappy.survey.score-subtext.strongly-agree": [
    {
      "type": 0,
      "value": "Strongly agree"
    }
  ],
  "jira.lovabilityFastSnappy.survey.score-subtext.strongly-disagree": [
    {
      "type": 0,
      "value": "Strongly disagree"
    }
  ],
  "jira.lovabilityFastSnappy.survey.title": [
    {
      "type": 0,
      "value": "Jira feedback survey"
    }
  ],
  "jira.user.premium-plan.requested.email.explaination": [
    {
      "type": 0,
      "value": "You can try Jira Premium for free with no commitment. This trial period includes access\n\t\t\t\tto our advanced planning features plus other great functionalities that unlock new ways\n\t\t\t\tof working for your teams."
    }
  ],
  "jira.user.premium-plan.requested.email.greeting": [
    {
      "type": 0,
      "value": "Hi,"
    }
  ],
  "jira.user.premium-plan.requested.email.learn-more": [
    {
      "type": 0,
      "value": "Learn more about Jira Premium."
    }
  ],
  "jira.user.premium-plan.requested.email.start-trial": [
    {
      "type": 0,
      "value": "Start your Jira Premium trial"
    }
  ],
  "jira.user.premium-plan.requested.email.subject": [
    {
      "type": 0,
      "value": "[JIRA] "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " has requested a free trial of Jira Premium"
    }
  ],
  "jira.user.premium-plan.requested.email.text": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " has requested a free trial of Jira Premium."
    }
  ],
  "note.added.by.user": [
    {
      "type": 1,
      "value": "userName"
    },
    {
      "type": 0,
      "value": " added this note"
    }
  ],
  "post-office.jira-pulsar.jira-issue-approval.sample-mobile-notification-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, this is a mobile push notification test from post office."
    }
  ],
  "post-office.jira-pulsar.jira-issue-archived.sample-mobile-notification-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, this is a mobile push notification test from post office."
    }
  ],
  "post-office.jira-pulsar.jira-issue-closed.sample-mobile-notification-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, this is a mobile push notification test from post office."
    }
  ],
  "post-office.jira-pulsar.jira-issue-comment-delete.sample-mobile-notification-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, this is a mobile push notification test from post office."
    }
  ],
  "post-office.jira-pulsar.jira-issue-comment-update.sample-mobile-notification-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, this is a mobile push notification test from post office."
    }
  ],
  "post-office.jira-pulsar.jira-issue-delete.sample-mobile-notification-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, this is a mobile push notification test from post office."
    }
  ],
  "post-office.jira-pulsar.jira-issue-generic.sample-mobile-notification-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, this is a mobile push notification test from post office."
    }
  ],
  "post-office.jira-pulsar.jira-issue-moved.sample-mobile-notification-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, this is a mobile push notification test from post office."
    }
  ],
  "post-office.jira-pulsar.jira-issue-resolved.sample-mobile-notification-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, this is a mobile push notification test from post office."
    }
  ],
  "post-office.jira-pulsar.jira-issue-update.sample-mobile-notification-message.no-translate": [
    {
      "type": 0,
      "value": "Hello, this is a mobile push notification test from post office."
    }
  ],
  "post-office.placement.jira-top-banner.primary-message": [
    {
      "type": 0,
      "value": "As we roll out 'work' as the new term for items tracked in Jira, you may still see 'issue' in some areas."
    }
  ],
  "postoffice.jira.issue.common.avatar.no-translate": [
    {
      "type": 0,
      "value": "Avatar"
    }
  ],
  "postoffice.jira.issue.common.reply-button": [
    {
      "type": 0,
      "value": "Reply"
    }
  ],
  "postoffice.jira.issue.common.visibility-level": [
    {
      "type": 0,
      "value": "Restricted to "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "name"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "type"
    }
  ],
  "postoffice.jira.issue.metioned.avatar.no-translate": [
    {
      "type": 0,
      "value": "Avatar"
    }
  ],
  "postoffice.jira.issue.share-search.shared-with.no-translate": [
    {
      "type": 0,
      "value": "sharedWithUser"
    }
  ],
  "postoffice.jira.issue.work.started.avatar.no-translate": [
    {
      "type": 0,
      "value": "Avatar"
    }
  ],
  "postoffice.jira.issue.work.stopped.avatar.no-translate": [
    {
      "type": 0,
      "value": "Avatar"
    }
  ],
  "postoffice.jira.issue.worklogged.avatar.no-translate": [
    {
      "type": 0,
      "value": "Avatar"
    }
  ],
  "postoffice.jira.project.event.avatar.no-translate": [
    {
      "type": 0,
      "value": "avatar"
    }
  ],
  "postoffice.jira.project.event.blueprint.no-translate": [
    {
      "type": 0,
      "value": "blueprintLogo"
    }
  ],
  "postoffice.jira.project.event.globe.no-translate": [
    {
      "type": 0,
      "value": "globeLogo"
    }
  ],
  "postoffice.jira.project.event.logo.no-translate": [
    {
      "type": 0,
      "value": "logo"
    }
  ],
  "postoffice.jira.project.event.write.no-translate": [
    {
      "type": 0,
      "value": "writeLogo"
    }
  ],
  "ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.body": [
    {
      "type": 0,
      "value": "Everything else about how you use these containers remains the same."
    }
  ],
  "ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.learn-more": [
    {
      "type": 0,
      "value": "Learn more"
    }
  ],
  "ptr-changeboarding-space-navigation-spotlight.message-templates.spotlight.title": [
    {
      "type": 0,
      "value": "Jira 'projects' are now called 'spaces'"
    }
  ],
  "push.mobile.issue.approval.requested.description": [
    {
      "type": 0,
      "value": "on "
    },
    {
      "type": 1,
      "value": "summary"
    }
  ],
  "push.mobile.issue.approval.requested.title": [
    {
      "type": 0,
      "value": "Approval requested"
    }
  ],
  "push.mobile.issue.assignment.description.assigned.others": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " assigned "
    },
    {
      "type": 1,
      "value": "summary"
    },
    {
      "type": 0,
      "value": " to "
    },
    {
      "type": 1,
      "value": "assignee"
    }
  ],
  "push.mobile.issue.assignment.description.assigned.you": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " assigned you to "
    },
    {
      "type": 1,
      "value": "summary"
    }
  ],
  "push.mobile.issue.assignment.description.unassigned.others": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " unassigned "
    },
    {
      "type": 1,
      "value": "oldAssignee"
    },
    {
      "type": 0,
      "value": " from "
    },
    {
      "type": 1,
      "value": "summary"
    }
  ],
  "push.mobile.issue.assignment.description.unassigned.you": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " unassigned you from "
    },
    {
      "type": 1,
      "value": "summary"
    }
  ],
  "push.mobile.issue.attachment.added.description": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " added an attachment to "
    },
    {
      "type": 1,
      "value": "summary"
    }
  ],
  "push.mobile.issue.attachment.added.description.redacted": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " added an attachment"
    }
  ],
  "push.mobile.issue.comment.added.android.description": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " commented on "
    },
    {
      "type": 1,
      "value": "summary"
    }
  ],
  "push.mobile.issue.comment.added.ios.body.redacted": [
    {
      "type": 0,
      "value": "commented on this work item"
    }
  ],
  "push.mobile.issue.comment.added.ios.subtitle": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " commented on "
    },
    {
      "type": 1,
      "value": "summary"
    }
  ],
  "push.mobile.issue.comment.mention.android.description": [
    {
      "type": 0,
      "value": "📣 "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " mentioned you on "
    },
    {
      "type": 1,
      "value": "summary"
    }
  ],
  "push.mobile.issue.comment.mention.android.description.redacted": [
    {
      "type": 0,
      "value": "📣 "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " mentioned you in a comment on "
    },
    {
      "type": 1,
      "value": "summary"
    }
  ],
  "push.mobile.issue.comment.mention.ios.subtitle": [
    {
      "type": 0,
      "value": "📣 "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " mentioned you on "
    },
    {
      "type": 1,
      "value": "summary"
    }
  ],
  "push.mobile.issue.comment.mention.ios.subtitle.redacted": [
    {
      "type": 0,
      "value": "📣 "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " mentioned you in a comment on this work item"
    }
  ],
  "push.mobile.issue.create.android.description": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " created a work item"
    }
  ],
  "push.mobile.issue.create.android.title": [
    {
      "type": 0,
      "value": "Work item Created"
    }
  ],
  "push.mobile.issue.create.ios.body.redacted": [
    {
      "type": 0,
      "value": "Open to view work item details"
    }
  ],
  "push.mobile.issue.create.ios.subtitle": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " created a work item"
    }
  ],
  "push.mobile.issue.transition.description.resolved": [
    {
      "type": 0,
      "value": "✔ "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " resolved "
    },
    {
      "type": 1,
      "value": "summary"
    }
  ],
  "push.mobile.issue.transition.description.resolved.redacted": [
    {
      "type": 0,
      "value": "✔ "
    },
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " resolved this work item"
    }
  ],
  "push.mobile.issue.transition.ios.description": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " moved "
    },
    {
      "type": 1,
      "value": "summary"
    },
    {
      "type": 0,
      "value": " to "
    },
    {
      "type": 1,
      "value": "status"
    }
  ],
  "push.mobile.issue.transition.ios.description.redacted": [
    {
      "type": 1,
      "value": "user"
    },
    {
      "type": 0,
      "value": " moved "
    },
    {
      "type": 1,
      "value": "summary"
    },
    {
      "type": 0,
      "value": " to "
    },
    {
      "type": 1,
      "value": "status"
    }
  ],
  "st-office.placement.jira-top-banner.primary-cta-text": [
    {
      "type": 0,
      "value": "Read about this terminology change"
    }
  ],
  "template..project-deletion-reminder.restore-link.multiple-project": [
    {
      "type": 0,
      "value": " Restore"
    }
  ],
  "template..project-deletion-reminder.restore-link.single-project": [
    {
      "type": 0,
      "value": " Restore"
    }
  ],
  "template..project-deletion-reminder.trash-link.multiple-project": [
    {
      "type": 0,
      "value": " Trash"
    }
  ],
  "template.project-deletion-reminder.generic-message.mutiple-projects": [
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " project"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " projects"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "projectCount"
    },
    {
      "type": 0,
      "value": " will be permanently deleted in 7 days "
    }
  ],
  "template.project-deletion-reminder.generic-message.single-project": [
    {
      "type": 0,
      "value": "The project will be permanently deleted in 7 days "
    }
  ],
  "template.project-deletion-reminder.view-more-projects-message": [
    {
      "type": 0,
      "value": "+ "
    },
    {
      "type": 1,
      "value": "remainingProjectCount"
    },
    {
      "type": 0,
      "value": " other projects currently in "
    }
  ],
  "template.project-event-user-invited-new.custom-message-heading": [
    {
      "type": 0,
      "value": "A note from "
    },
    {
      "type": 1,
      "value": "inviterName"
    }
  ],
  "template.project-event-user-invited-new.custom-message-heading-no-inviter": [
    {
      "type": 0,
      "value": "A note from the admin"
    }
  ],
  "template.project-event-user-invited-new.footer.sent-by": [
    {
      "type": 0,
      "value": "This message was sent to you by Atlassian Cloud"
    }
  ],
  "template.project-event-user-invited-new.join-space": [
    {
      "type": 0,
      "value": "Join the space"
    }
  ],
  "template.project-event-user-invited-new.logo-alt-text": [
    {
      "type": 0,
      "value": "Jira logo"
    }
  ],
  "template.project-event-user-invited-new.product-description": [
    {
      "children": [
        {
          "type": 0,
          "value": "What is Jira?"
        }
      ],
      "type": 8,
      "value": "strong"
    },
    {
      "type": 0,
      "value": " A software tool for project and work item tracking with your team"
    }
  ],
  "template.project-event-user-invited-new.social-proof-text": [
    {
      "type": 1,
      "value": "numberOfCustomers"
    },
    {
      "type": 0,
      "value": "+ customers use Jira to move work forward"
    }
  ],
  "template.project-event-user-invited-new.title-generic": [
    {
      "type": 0,
      "value": "You've been invited to join your team in Jira"
    }
  ],
  "template.project-event-user-invited-new.title-inviter": [
    {
      "type": 1,
      "value": "inviterDisplayName"
    },
    {
      "type": 0,
      "value": " invited you to join your team in Jira"
    }
  ],
  "template.project-event-user-invited-new.welcome-message": [
    {
      "type": 1,
      "value": "waveEmoji"
    },
    {
      "type": 0,
      "value": " G'day, "
    },
    {
      "type": 1,
      "value": "recipientFirstName"
    }
  ],
  "template.project-event-user-invited.invited-custom-message": [
    {
      "type": 1,
      "value": "customMessage"
    }
  ],
  "template.project-event-user-invited.invited-message": [
    {
      "type": 1,
      "value": "userName"
    },
    {
      "type": 0,
      "value": "  invited you to "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " "
        },
        {
          "type": 1,
          "value": "projectName"
        },
        {
          "type": 0,
          "value": " "
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "template.project.archived.event.admins.permission.message": [
    {
      "type": 0,
      "value": "Only Jira admins can restore the space."
    }
  ],
  "template.project.deleted.event.admins.permission.message": [
    {
      "type": 0,
      "value": "Only Jira admins can restore the project."
    }
  ],
  "template.project.event.project.archive.restore.body.template": [
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "userName"
    },
    {
      "type": 0,
      "value": " restored this project from archive on "
    },
    {
      "type": 1,
      "value": "eventTime"
    }
  ],
  "template.project.event.project.archived.body.template": [
    {
      "type": 1,
      "value": "userName"
    },
    {
      "type": 0,
      "value": " archived this space on "
    },
    {
      "type": 1,
      "value": "eventTime"
    }
  ],
  "template.project.event.project.archived.body.template.generic.message": [
    {
      "type": 0,
      "value": "This space and its work items, components, attachments, and versions will be available in the "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " archive "
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " forever"
    }
  ],
  "template.project.event.project.deleted.body.template": [
    {
      "type": 1,
      "value": "userName"
    },
    {
      "type": 0,
      "value": " moved this project to trash on "
    },
    {
      "type": 1,
      "value": "eventTime"
    }
  ],
  "template.project.event.project.deleted.body.template.generic.message": [
    {
      "type": 0,
      "value": "The project, including all its issues, components, attachments, and versions will be available in the "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " trash "
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " for 60 days after which it will be permanently deleted."
    }
  ],
  "template.project.event.project.deleted.failure.body.template.generic.message": [
    {
      "type": 0,
      "value": "It's probably a temporary problem. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " Go to trash "
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " and try again. If it persists, please contact support."
    }
  ],
  "template.project.event.project.deleted.restore.body.template": [
    {
      "type": 0,
      "value": " "
    },
    {
      "type": 1,
      "value": "userName"
    },
    {
      "type": 0,
      "value": " restored this project from trash on "
    },
    {
      "type": 1,
      "value": "eventTime"
    }
  ],
  "template.project.event.project.deletion.failure.body.template": [
    {
      "type": 0,
      "value": "We couldn't delete this project"
    }
  ],
  "template.project.event.project.privacy.contactus.template": [
    {
      "type": 0,
      "value": "Contact us"
    }
  ],
  "template.project.event.project.privacy.copyright.template": [
    {
      "type": 0,
      "value": "Copyright 2025 Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "template.project.event.project.privacy.location.template": [
    {
      "type": 0,
      "value": "We are located at 341 George Street, Sydney, NSW, 2000, Australia."
    }
  ],
  "template.project.event.project.privacy.policy.template": [
    {
      "type": 0,
      "value": "Privacy policy"
    }
  ],
  "template.project.event.project.privacy.policy.template.dot": [
    {
      "type": 0,
      "value": "."
    }
  ],
  "template.project.event.project.user.invited.collborate.message": [
    {
      "type": 0,
      "value": "Collaborate, align, and deliver work, all in "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " one place "
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "template.project.event.project.user.invited.collect.message": [
    {
      "type": 0,
      "value": "Collect and send work to other teams or stakeholders using "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " forms "
        }
      ],
      "type": 8,
      "value": "b"
    }
  ],
  "template.project.event.project.user.invited.join.link": [
    {
      "type": 0,
      "value": "Join the Project"
    }
  ],
  "template.project.event.project.user.invited.learn.more.message": [
    {
      "type": 0,
      "value": "Learn more about Jira "
    }
  ],
  "template.project.event.project.user.invited.use.jira.generic.message": [
    {
      "type": 0,
      "value": "Use Jira to..."
    }
  ],
  "template.project.event.project.user.invited.view.work.message": [
    {
      "type": 0,
      "value": "View work your way using the "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " list, board, calendar "
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " and "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " timeline "
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " views"
    }
  ],
  "template.subscription.filter.count.issue-term-refresh": [
    {
      "type": 0,
      "value": " ("
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " work item"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " work items"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "total"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "template.subscription.filter.html.subset.issue-term-refresh": [
    {
      "type": 0,
      "value": "Displaying "
    },
    {
      "type": 1,
      "value": "actual"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " matched work item"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " matched work items"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "total"
    },
    {
      "type": 0,
      "value": ". "
    }
  ],
  "template.subscription.filter.html.view.filter.work-items": [
    {
      "type": 0,
      "value": "View all of them"
    }
  ],
  "template.subscription.filter.redacted.html.edit": [
    {
      "type": 0,
      "value": "You may edit this subscription "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " here "
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " "
    }
  ],
  "template.subscription.filter.redacted.html.view.filter": [
    {
      "type": 0,
      "value": "Details are hidden to protect sensitive data. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": " View the filter "
        }
      ],
      "type": 8,
      "value": "a"
    },
    {
      "type": 0,
      "value": " in Jira"
    }
  ],
  "template.subscription.filter.subcount.issue-term-refresh": [
    {
      "type": 0,
      "value": "  ("
    },
    {
      "type": 1,
      "value": "actual"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "total"
    },
    {
      "type": 0,
      "value": " work items)"
    }
  ],
  "template.subscription.filter.text.count.issue-term-refresh": [
    {
      "type": 0,
      "value": " ("
    },
    {
      "offset": 0,
      "options": {
        "one": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " work item"
            }
          ]
        },
        "other": {
          "value": [
            {
              "type": 7
            },
            {
              "type": 0,
              "value": " work items"
            }
          ]
        }
      },
      "pluralType": "cardinal",
      "type": 6,
      "value": "total"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "template.subscription.filter.text.subcount.issue-term-refresh": [
    {
      "type": 0,
      "value": " ("
    },
    {
      "type": 1,
      "value": "actual"
    },
    {
      "type": 0,
      "value": " of "
    },
    {
      "type": 1,
      "value": "total"
    },
    {
      "type": 0,
      "value": " work items)"
    }
  ],
  "user.avatar.alt": [
    {
      "type": 0,
      "value": "User avatar"
    }
  ]
}